/**
 * @namespace ang.order_portal.controller
 */

import { RoleEnum } from "@ang/shared-types";
import { User } from "../user";
import BaseController from "./BaseController";

export default class LandingPageController extends BaseController {
	onInit(): void {
	}

	onOrderPressed(): void {
		const oRouter = this.getRouter();
		oRouter.navTo("orders");
	}

	async onUsersMgmtPressed(): Promise<void> {
		if (User.getInstance().getRole() == RoleEnum.USER) {
			this.showMessage(await this.getResourceBundle().then((bundle) => {
					return bundle.getText("accessNotAuthorized");
				}));
			return;
		}

		const oRouter = this.getRouter();
		oRouter.navTo("userDetails");
	}
}
